import { createFileRoute, Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useEffect, useState } from "react";
import { confirmNewsletter } from "@/lib/newsletter.functions";

export const Route = createFileRoute("/novice/potrditev")({
  head: () => ({
    meta: [
      { title: "Potrditev prijave — kupish.si" },
      { name: "description", content: "Potrditev prijave na Unikatno pošto." },
      { name: "robots", content: "noindex,follow" },
    ],
      links: [{ rel: "canonical", href: "https://kupish.si/novice/potrditev" }],
  }),
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === "string" ? search.token : "",
  }),
  component: Page,
});

type State = "loading" | "confirmed" | "already" | "expired" | "invalid" | "error";

function Page() {
  const { token } = Route.useSearch();
  const confirm = useServerFn(confirmNewsletter);
  const [state, setState] = useState<State>("loading");
  const [message, setMessage] = useState<string>("Potrjujem prijavo…");

  useEffect(() => {
    if (!token) {
      setState("invalid");
      setMessage("Manjka potrditveni žeton.");
      return;
    }
    let cancelled = false;
    confirm({ data: { token } })
      .then((res) => {
        if (cancelled) return;
        setState(res.status);
        setMessage(res.message);
      })
      .catch(() => {
        if (cancelled) return;
        setState("error");
        setMessage("Prišlo je do napake. Poskusite znova kasneje.");
      });
    return () => {
      cancelled = true;
    };
  }, [token, confirm]);

  const headline =
    state === "confirmed"
      ? "Prijava potrjena 🎉"
      : state === "already"
      ? "Prijava je že potrjena"
      : state === "expired"
      ? "Povezava je potekla"
      : state === "invalid"
      ? "Neveljavna povezava"
      : state === "error"
      ? "Nekaj je šlo narobe"
      : "Potrjujem prijavo…";

  return (
    <section className="mx-auto max-w-xl px-6 py-24 text-center">
      <div className="eyebrow">Novičnik</div>
      <h1 className="font-serif text-3xl md:text-4xl mt-3">{headline}</h1>
      <p className="mt-4 text-muted-foreground">{message}</p>

      <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="bg-primary text-primary-foreground px-5 py-2.5 text-sm tracking-wider uppercase hover:opacity-90"
        >
          Domov
        </Link>
        <Link
          to="/izdelki"
          className="border border-border px-5 py-2.5 text-sm tracking-wider uppercase hover:border-accent hover:text-accent transition-colors"
        >
          Vsi izdelki
        </Link>
      </div>
    </section>
  );
}
